<template>
    <div class="card" v-if="registrations">

        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="mb-0 text-uppercase">{{ $t('common.degrees') }}</h3>
                </div>
                <div class="col-6 text-right">
                    <button-radio-group 
                        :options="orderOptions"
                        button-classes="btn-secondary btn-sm"
                        v-model="order"
                        class="d-inline">
                    </button-radio-group>
                </div>
            </div>
        </div>

        <p class="card-body mt-2" v-if="empty">
            <strong>{{ $t('dashboard.no-degree') }}</strong>
        </p>

        <div v-if="!empty">

            <el-table class="table-responsive table-flush"
                    :show-header="false"
                    :data="registrationsWithTotal">

                <el-table-column class-name="registration">
                    <template v-slot="{row}">
                        <div class="padding" :class="{ disabled: row.withdrawed }">
                            <h3 class="mb-2" v-if="row.cohort">
                                <a href="#" @click.prevent="openRegistration(row)">
                                    {{ row.degree.name }}
                                </a>
                            </h3>
                            <h3 class="mb-2" v-else>
                                {{ row.degree.name }}
                            </h3>
                            <base-progress type="info" :value="progress(row)" v-if="!row.withdrawed">
                            </base-progress>

                            <span class="d-block" v-if="!row.withdrawed">
                                <strong>{{ progress(row) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                                <span v-if="remedials(row)">
                                    <br><strong>{{ remedials(row) }}</strong> {{ $t('dashboard.remedial-s').toLowerCase() }}
                                </span>
                            </span>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column>
                    <template v-slot="{row}">

                        <div class="padding" :class="{ disabled: row.withdrawed }" v-if="row.cohort">

                            <span class="d-block mb-1" v-if="row.state.from">
                                <i class="fas fa-calendar-alt mr-1"></i> {{ date(row.state.from) }} to {{ date(row.state.to) }}
                            </span>

                            <span class="d-block mb-1">
                                <i class="fas fa-users mr-1"></i> {{ row.cohort.name }}
                            </span>

                            <span class="d-block mb-1" v-if="row.state.meta && row.state.meta.go_ground">
                                <i class="fas fa-plane-departure mr-1"></i>
                                {{ $t('degrees.go-ground') }}
                            </span>
                        </div>

                    </template>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {

        props: {

            learner: {
                type: Object,
            },
        },

        data() {
            return {
                moment: moment,
                registrations: null,
                order: 'asc',
            }
        },

        created() {
            this.$loader.show()
            axios.get('/astral/api/front/dashboard/learners/'+this.learner.id+'/registrations')
            .then(resp => {
                this.registrations = resp.data.data
                this.$permissions.setRights(resp.data.included.rights)
                this.$loader.hide()
            })
        },

        computed: {

            empty() {
                return this.registrations && this.registrations.length == 0
            },

            orderOptions() {
                return [
                    { value: 'asc', label: '<i class="fas fa-arrow-down"></i>' },
                    { value: 'desc', label: '<i class="fas fa-arrow-up"></i>' },
                ]
            },

            registrationsWithTotal() {
                const registrations = [...this.registrations.filter(reg => !reg.withdrawed)]
                registrations.push(this.totalRegistration)
                return registrations
            },

            
            totalRegistration() {
                let totalState = {
                    remedial_sessions: 0,
                    sessions_count: 0,
                    completed_sessions: 0,
                }
                this.registrations.map(registration => {
                    if (registration.state) {
                        totalState.remedial_sessions += registration.state.remedial_sessions
                        totalState.sessions_count += registration.state.sessions_count
                        totalState.completed_sessions += registration.state.completed_sessions
                    }
                })
                return { degree: { name: 'TOTAL' }, state: totalState }
            }
        },
        
        watch: {
            order(value) {
                this.registrations.reverse()
            }
        },

        methods: {

            state(registration) {
                return registration.state
            },

            progress(registration) {
                const state = this.state(registration)
                if (!state || state.sessions_count == 0) {
                    return 0
                }
                let progress = (state.completed_sessions ? state.completed_sessions : 0) * 100 / state.sessions_count
                return parseInt(progress)
            },

            remedials(registration) {
                const state = this.state(registration)
                if (!state) {
                    return 0
                }
                return state.remedial_sessions
            },

            otherCohorts(registration) {
                const state = this.state(registration)
                if (!state || !state.other_cohorts || state.other_cohorts.length == 0) {
                    return false
                }
                return state.other_cohorts
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            openRegistration(registration) {
                this.$router.push({
                    name: 'report-learner-registration-results',
                    params: {
                        learnerId: this.learner.id,
                        registrationId: registration.id
                    }
                })
            },
        }
    }
</script>

<style scoped>

    .card >>> th,
    .card >>> td {
        padding-right: 0;
    }
    .padding {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .padding.disabled {
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .disabled, .disabled h3 {
        color: #bbb !important;
        margin-bottom: 0 !important;
        font-size: 0.8rem;
    }

</style>
